import type { ReactElement } from 'react';

export interface TokenBudgetBarProps {
  readonly tokensUsed: number;
  readonly hardCap: number;
}

export default function TokenBudgetBar({ tokensUsed, hardCap }: TokenBudgetBarProps): ReactElement {
  const ratio = hardCap > 0 ? tokensUsed / hardCap : 0;
  const zone = ratio >= 0.90 ? 'red' : ratio >= 0.75 ? 'amber' : 'normal';
  const color = zone === 'red' ? 'var(--wayne-red)'
              : zone === 'amber' ? 'var(--wayne-amber)'
              : 'var(--wayne-ink-3)';
  return (
    <div role="progressbar"
         aria-label="Context token budget"
         aria-valuenow={tokensUsed}
         aria-valuemax={hardCap}
         data-zone={zone}
         className="h-1.5 rounded-full overflow-hidden bg-wayne-surface-2"
         style={{ width: '100%' }}>
      <div style={{ width: `${Math.min(100, ratio * 100)}%`, height: '100%', background: color,
                     transition: 'width 200ms ease' }} />
    </div>
  );
}
